var UitkHeadingTagMap = [
    ['h1', 'h1'],
    ['h2', 'h2'],
    ['h3', 'h3'],
    ['h4', 'h4'],
    ['h5', 'h5'],
    ['h6', 'h6']
];
var defaultMenuHeadingTag = 'h3';
var defaultMenuListHeadingTag = 'h4';
var UitkHeadingTags = new Map(UitkHeadingTagMap);

export { UitkHeadingTags, defaultMenuHeadingTag, defaultMenuListHeadingTag };
